import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SERVICES = [
  {
    id: 'sua',
    badge: 'CAM KẾT BÁN',
    title: 'Sửa — Cam Kết Bán',
    subtitle: 'Bán nhanh hơn – giá cao hơn – có chiến lược',
    desc: 'Tối ưu tài sản để tăng giá trị bán ≥2–3 lần chi phí sửa. Không chỉ làm đẹp — chúng tôi định vị đúng để đúng người mua đúng giá.',
    features: ['Tăng giá trị thực sự', 'Định vị đúng khách mua', 'Kiểm soát giá bán', 'Rút ngắn thời gian bán'],
    result: 'Tăng 15–30% giá bán',
    icon: 'ri-hammer-line',
    link: '/dich-vu/sua-cam-ket-ban',
    cta: 'Xem Chi Tiết',
    color: 'teal',
  },
  {
    id: 'xay',
    badge: 'CAM KẾT THUÊ',
    title: 'Xây — Cam Kết Thuê',
    subtitle: 'Tạo dòng tiền bền vững – không cần tự vận hành',
    desc: 'Thiết kế và vận hành mô hình cho thuê tối ưu, tăng 2–5 lần dòng tiền so với cho thuê truyền thống. Nhà bạn, tiền về hàng tháng.',
    features: ['Tối ưu công năng sử dụng', 'Chuẩn vận hành CHDV', 'Quản lý toàn bộ cho bạn', 'Báo cáo dòng tiền minh bạch'],
    result: 'Dòng tiền tăng 2–5×',
    icon: 'ri-building-2-line',
    link: '/dich-vu/xay-cam-ket-thue',
    cta: 'Xem Chi Tiết',
    color: 'gold',
  },
  {
    id: 'vanhanh',
    badge: 'QUẢN LÝ CHUYÊN NGHIỆP',
    title: 'Vận Hành Tài Sản',
    subtitle: 'Tài sản đang chạy, tiền vào tự động, bạn không cần lo',
    desc: 'Dịch vụ vận hành toàn diện cho chủ nhà không có thời gian — từ quản lý khách thuê, bảo trì đến tối ưu giá thuê theo thị trường.',
    features: ['Quản lý khách thuê 24/7', 'Bảo trì & sửa chữa kịp thời', 'Tối ưu giá thuê liên tục', 'Báo cáo tài chính hàng tháng'],
    result: 'Công suất lấp đầy >90%',
    icon: 'ri-settings-3-line',
    link: '/dich-vu/van-hanh',
    cta: 'Xem Chi Tiết',
    color: 'neutral',
  },
];

function ServiceCard({ svc }: { svc: typeof SERVICES[0] }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`bg-white rounded-2xl overflow-hidden border transition-all duration-300 cursor-pointer group flex flex-col
        ${open ? 'border-[#004D4D]/30' : 'border-[#E5E7EB] hover:border-[#004D4D]/20'}`}
      onClick={() => setOpen(v => !v)}
    >
      {/* Top band */}
      <div className={`h-1.5 w-full ${svc.color === 'teal' ? 'bg-[#004D4D]' : svc.color === 'gold' ? 'bg-[#C5A059]' : 'bg-neutral-400'}`} />

      <div className="p-7 flex flex-col flex-1">
        {/* Badge + Icon */}
        <div className="flex items-start justify-between mb-5">
          <span className={`text-[10px] font-heading font-bold tracking-widest px-3 py-1 rounded-full ${
            svc.color === 'teal' ? 'bg-[#004D4D]/10 text-[#004D4D]' :
            svc.color === 'gold' ? 'bg-[#C5A059]/15 text-[#A8854A]' :
            'bg-neutral-100 text-neutral-600'
          }`}>
            {svc.badge}
          </span>
          <div className="flex items-center gap-2">
            <div className={`w-10 h-10 flex items-center justify-center rounded-xl transition-colors duration-200 ${
              open
                ? svc.color === 'teal' ? 'bg-[#004D4D]' : svc.color === 'gold' ? 'bg-[#C5A059]' : 'bg-neutral-800'
                : svc.color === 'teal' ? 'bg-[#E6F0F0] group-hover:bg-[#004D4D]/[0.15]' : svc.color === 'gold' ? 'bg-[#F5EDD8] group-hover:bg-[#C5A059]/[0.20]' : 'bg-neutral-100 group-hover:bg-neutral-200'
            }`}>
              <i className={`${svc.icon} text-xl transition-colors duration-200 ${
                open ? 'text-white' : svc.color === 'teal' ? 'text-[#004D4D]' : svc.color === 'gold' ? 'text-[#C5A059]' : 'text-neutral-600'
              }`} />
            </div>
            <div className={`w-7 h-7 flex items-center justify-center rounded-full transition-all duration-200 ${
              open ? 'bg-[#004D4D]/10 rotate-45' : 'bg-neutral-100 group-hover:bg-[#004D4D]/8'
            }`}>
              <i className={`ri-add-line text-sm transition-colors duration-200 ${open ? 'text-[#004D4D]' : 'text-neutral-500'}`} />
            </div>
          </div>
        </div>

        <h3 className="font-heading font-extrabold text-xl text-[#004D4D] mb-1">{svc.title}</h3>
        <p className={`text-xs font-sans font-medium mb-0 transition-colors duration-200 ${open ? 'text-[#004D4D]/70' : 'text-neutral-500'}`}>{svc.subtitle}</p>

        {/* Expandable content */}
        <div className={`overflow-hidden transition-all duration-300 ${open ? 'max-h-[500px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`}>
          <p className="text-[#374151] text-sm font-sans leading-relaxed mb-5">{svc.desc}</p>

          {/* Features */}
          <ul className="space-y-2 mb-5">
            {svc.features.map((f) => (
              <li key={f} className="flex items-center gap-2.5 text-sm font-sans">
                <i className={`ri-check-line flex-shrink-0 ${
                  svc.color === 'teal' ? 'text-[#004D4D]' : svc.color === 'gold' ? 'text-[#C5A059]' : 'text-neutral-500'
                }`} />
                <span className="text-neutral-700">{f}</span>
              </li>
            ))}
          </ul>

          {/* Result */}
          <div className={`rounded-xl p-3 mb-5 text-center ${
            svc.color === 'teal' ? 'bg-[#004D4D]/6' : svc.color === 'gold' ? 'bg-[#C5A059]/10' : 'bg-neutral-100'
          }`}>
            <span className={`font-heading font-bold text-sm ${
              svc.color === 'teal' ? 'text-[#004D4D]' : svc.color === 'gold' ? 'text-[#A8854A]' : 'text-neutral-700'
            }`}>
              📊 {svc.result}
            </span>
          </div>

          {/* CTA */}
          <button
            onClick={(e) => { e.stopPropagation(); navigate(svc.link); }}
            className={`w-full py-3.5 rounded-full font-heading font-bold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap ${
              svc.color === 'teal'
                ? 'bg-[#004D4D] text-white hover:bg-[#0A5F5F]'
                : svc.color === 'gold'
                ? 'bg-[#C5A059] text-[#002626] hover:bg-[#D4B575]'
                : 'bg-neutral-900 text-white hover:bg-neutral-700'
            }`}
          >
            {svc.cta} →
          </button>
        </div>

        {/* Collapsed hint */}
        {!open && (
          <p className={`text-xs font-sans mt-3 transition-opacity duration-200 opacity-0 group-hover:opacity-100 ${
            svc.color === 'teal' ? 'text-[#004D4D]/60' : svc.color === 'gold' ? 'text-[#C5A059]/70' : 'text-neutral-400'
          }`}>
            Nhấn để xem chi tiết →
          </p>
        )}
      </div>
    </div>
  );
}

export default function ServicesSection() {
  const navigate = useNavigate();

  return (
    <section id="services" className="bg-[#F2F4F5] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <span className="text-[#C5A059] text-xs font-heading font-bold tracking-widest uppercase">
              3 DỊCH VỤ CỐT LÕI
            </span>
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-[#004D4D] mt-3 leading-tight">
              Giải pháp cho mọi<br />loại tài sản bỏ phí
            </h2>
          </div>
          <p className="text-[#374151] text-sm font-sans leading-relaxed max-w-xs">
            Dù bạn muốn bán, cho thuê hay tối ưu tài sản hiện tại — UPLIVING có giải pháp phù hợp.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {SERVICES.map((svc) => (
            <ServiceCard key={svc.id} svc={svc} />
          ))}
        </div>

        {/* Góp Vốn Cam Kết Banner */}
        <div className="mt-12 bg-gradient-to-r from-[#002626] via-[#004D4D] to-[#002626] rounded-2xl p-8 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-5">
            <div className="w-14 h-14 flex items-center justify-center bg-[#C5A059]/20 border border-[#C5A059]/40 rounded-2xl flex-shrink-0">
              <i className="ri-shield-star-line text-[#C5A059] text-2xl" />
            </div>
            <div>
              <div className="flex items-center gap-2 mb-1">
                <span className="bg-[#C5A059] text-[#002626] text-[10px] font-heading font-extrabold px-2.5 py-1 rounded-full uppercase tracking-wide whitespace-nowrap">Ký Quỹ Cam Kết</span>
                <span className="text-white/50 text-xs font-sans">· Mô hình độc bản của UPLIVING</span>
              </div>
              <p className="font-heading font-bold text-white text-lg leading-tight">
                Không đạt mục tiêu dòng tiền / giá bán —{' '}
                <span className="text-[#C5A059]">UPLIVING mất tiền ký quỹ</span>
              </p>
              <p className="text-white/60 text-sm font-sans mt-1">
                Thanh toán sau khi đạt kết quả. Rủi ro thuộc về chúng tôi, không phải bạn.
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <button
              onClick={() => navigate('/gop-von-ky-quy')}
              className="bg-[#C5A059] hover:bg-[#D4B575] text-[#002626] font-heading font-bold text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap"
            >
              Tìm Hiểu Mô Hình →
            </button>
            <button
              onClick={() => navigate('/bat-mach-tai-san')}
              className="bg-white/10 hover:bg-white/20 border border-white/30 text-white font-heading font-semibold text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap"
            >
              Đặt Lịch Bắt Mạch
            </button>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-8 text-center">
          <p className="text-[#374151] text-sm font-sans mb-4">
            Chưa biết dịch vụ nào phù hợp? Để UPLIVING phân tích tài sản của bạn
          </p>
          <button
            onClick={() => navigate('/bat-mach-tai-san')}
            className="inline-flex items-center gap-2 border-2 border-[#004D4D] text-[#004D4D] hover:bg-[#004D4D] hover:text-white font-heading font-bold text-sm px-8 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-stethoscope-line" />
            Đặt Lịch Bắt Mạch Miễn Phí
          </button>
        </div>

      </div>
    </section>
  );
}
